export const FORMULATION_TYPES = [
  { value: 'WP', label: 'WP (Wettable Powder)' },
  { value: 'SC', label: 'SC (Suspension Concentrate)' },
  { value: 'EC', label: 'EC (Emulsifiable Concentrate)' },
  { value: 'SL', label: 'SL (Soluble Liquid)' },
  { value: 'WG', label: 'WG (Water Dispersible Granule)' },
  { value: 'EW', label: 'EW (Emulsion in Water)' },
  { value: 'Other', label: 'Other' },
];

/**
 * Get formulation label by value
 * @param {string} value - e.g. 'WP', 'SC'
 * @returns {string} - e.g. 'WP (Wettable Powder)'
 */
export const getFormulationLabel = (value) => {
  const type = FORMULATION_TYPES.find(f => f.value === value);
  return type ? type.label : value;
};
